import { mergeChatMessages } from './history';
import type { ChatServerMessage } from './types';

/** A received message with the number of the request that returned it. */
export type ChatMessageObservation<TMessage extends ChatServerMessage> = {
  message: TMessage;
  requestId: number;
};

// A request that started later carries the newer state of a message, even
// when a slow scan finishes after it.
export const mergeChatObservations = <TMessage extends ChatServerMessage>(
  ...snapshots: ChatMessageObservation<TMessage>[][]
): ChatMessageObservation<TMessage>[] => {
  const observations = new Map<number, ChatMessageObservation<TMessage>>();
  for (const snapshot of snapshots) {
    for (const observation of snapshot) {
      const previous = observations.get(observation.message.id);
      if (!previous || observation.requestId > previous.requestId) {
        observations.set(observation.message.id, observation);
      }
    }
  }
  return [...observations.values()];
};

export const getObservedChatMessages = <TMessage extends ChatServerMessage>(
  observations: ChatMessageObservation<TMessage>[]
): TMessage[] =>
  mergeChatMessages(observations.map(observation => observation.message));
